module.exports = __webpack_public_path__ + "media/token_keno_end-0f0febd8c104101cad314b544880c1fb.mp3";